import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../config.js";
import { showToast } from "../components/toast";
import LoadingSpinner from "../components/LoadingSpinner";

const AssignParentOrderPopup = ({ orderId, isOpen, onClose, onSuccess }) => {
  const [parentOrders, setParentOrders] = useState([]);
  const [selectedParentOrderId, setSelectedParentOrderId] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const token = localStorage.getItem("authToken");

  // Fetch parent orders when modal opens
  useEffect(() => {
    if (isOpen && orderId) {
      fetchParentOrders();
    }
  }, [isOpen, orderId]);

  const fetchParentOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}orders/parent-orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        setParentOrders(response.data.data.parentOrders || []);
      }
    } catch (error) {
      console.error("Error fetching parent orders:", error);
      showToast.error("Failed to load parent orders");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedParentOrderId) {
      showToast.error("Please select a parent order");
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(
        `${API_URL}orders/assign-parent-order`,
        {
          id: Number(orderId),
          parentOrderId: Number(selectedParentOrderId),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        showToast.success("Order Updated Successfully");
        setTimeout(() => {
          onSuccess();
          onClose();
        }, 1000);
      } else {
        showToast.error(response.data.message || "Error While Updating Order");
      }
    } catch (error) {
      console.error("Error assigning parent order:", error);
      const errorMessage =
        error.response?.data?.message || "Error While Updating Order";
      showToast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setSelectedParentOrderId("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog" style={{ width: "30rem" }}>
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title" style={{ fontWeight: "bold", margin: 0 }}>
              Assign Parent Order
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleCancel}
              aria-label="Close"
              style={{
                fontSize: "1.5rem",
                color: "#555",
                background: "transparent",
                border: "none",
                lineHeight: "1",
                cursor: "pointer",
                padding: "0 5px",
                boxShadow: "none",
                outline: "none",
              }}
            >
              &times;
            </button>
          </div>
          <div className="modal-body">
            {loading && <LoadingSpinner />}
            <form onSubmit={handleSubmit} id="assignOrderForm">
              <input type="hidden" name="id" value={orderId} />
              <div className="panel-body">
                <div className="row">
                  <div className="col-md-12 alert alert-success m-b-10 successBox" style={{ display: "none" }}>
                    Order Updated Successfully
                  </div>
                  <div className="col-md-12 alert alert-danger m-b-10 errorBox" style={{ display: "none" }}>
                    Error While Updating Order
                  </div>
                  <table className="table table-condensed table-hover bg-white usertable" width="100%">
                    <tbody>
                      <tr className="subscriber-block">
                        <td>
                          <label>Orders</label>
                          <select
                            name="parentOrderId"
                            id="parentOrderId"
                            className="form-control"
                            value={selectedParentOrderId}
                            onChange={(e) => setSelectedParentOrderId(e.target.value)}
                            required
                          >
                            <option value="">
                              {parentOrders.length === 0
                                ? "No eligible parent orders available"
                                : "Select Parent Order"}
                            </option>
                            {parentOrders.map((order) => (
                              <option key={order.id} value={order.id}>
                                {order.orderid} ( Amt - {order.actual_amount} | Rem - {order.remaining_amt} )
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="col-md-12" style={{ textAlign: "right" }}>
                    <button
                      type="submit"
                      name="submit"
                      className="btn btn-primary"
                      disabled={submitting || parentOrders.length === 0}
                    >
                      {submitting ? "Submitting..." : "Submit"}
                    </button>
                    <button
                      type="button"
                      name="cancel"
                      className="btn btn-default ml-2"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignParentOrderPopup;